var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Merge PPTX" },
      on: { hide: _vm.closeHandler, show: _vm.onShowHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonOutline",
                {
                  attrs: {
                    variant: "outline-primary",
                    disabled: _vm.isLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "ButtonPrimary",
                {
                  attrs: { variant: "primary", disabled: _vm.isLoading },
                  on: { click: _vm.accept },
                },
                [_vm._v("\n      Merge\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.isLoading
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Enter file name:" } },
                  [
                    _c("b-form-input", {
                      attrs: {
                        type: "text",
                        placeholder: "Enter file name",
                        required: "",
                      },
                      model: {
                        value: _vm.resultName,
                        callback: function ($$v) {
                          _vm.resultName = $$v
                        },
                        expression: "resultName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "modal-load" }, [_c("b-spinner")], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }